"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const Place_1 = __importDefault(require("@mui/icons-material/Place"));
const react_intersection_observer_1 = require("react-intersection-observer");
const i18n_js_1 = __importDefault(require("i18n-js"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const ProgressiveImage_1 = __importDefault(require("../../../common/components/Other/ProgressiveImage"));
const StylingWrapper = styled_components_1.default.div `
  position: relative;
  cursor: pointer;
`;
const Item = styled_components_1.default.div `
  display: flex;
  position: relative;
  justify-content: space-between;
  height: 100%;
  margin-bottom: 1.58vmin;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  padding: 5px;

  .progressive-image {
    height: 120px;
    width: 120px;
    flex-shrink: 0;
    border-radius: 7px;
    @media (max-width: 480px) {
      height: 100px;
      width: 100px;
    }
  }
`;
const ItemImage = styled_components_1.default.div `
  height: 120px;
  width: 120px;
  flex-shrink: 0;
  border-radius: 7px;

  background: linear-gradient(
    12deg,
    ${props => props.theme.palette.mainAppColor.dark} 5%,
    ${props => props.theme.palette.mainAppColor.light} 25%,
    ${props => props.theme.palette.mainAppColor.main} 100%
  );

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: ${props => {
    if (props.src) {
        return props.src;
    }
    return null;
}};

  @media (max-width: 480px) {
    height: 100px;
    width: 100px;
  }
`;
const ItemContent = styled_components_1.default.div `
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 1rem;
  padding: 10px;
  justify-content: space-between;
`;
const TitleWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;

  img {
    display: block;
    width: 0.8rem;
    height: 0.8rem;
    margin-right: 8px;
  }

  p {
    margin-top: 0px;
    padding-right: 5px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 0px;
    color: #000;
  }
`;
const PlaceAndTime = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  height: 21px;
`;
const Place = styled_components_1.default.div `
  display: flex;
  align-items: center;
  font-weight: 200;
  color: #807e7e;

  svg {
    font-size: 0.8rem;
    margin-right: 2px;
    position: relative;
    bottom: 1px;
  }

  p {
    margin: 0px;
    max-height: 40px;

    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;
const Book = styled_components_1.default.div `
  cursor: ${props => (props.state !== 'not_bookable_anymore' ? 'pointer ' : 'initial')};
  display: flex;
  align-items: center;
  font-weight: 300;
  height: 21px;

  .booking-circle {
    height: 8px;
    width: 8px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;

    &.green {
      background-color: #4cd964;
    }

    &.red {
      background-color: #ff3b30;
    }

    &.blue {
      background-color: #5ac8fa;
    }

    &.yellow {
      background-color: #ffcc00;
    }
  }

  &.hidden {
    visibility: hidden;
  }
`;
const ListItem = ({ withLazyLoad = true, content, 
// withProgressiveImage = true,
venue, index, history, location, }) => {
    const [isVisible, setIsVisible] = (0, react_1.useState)(false);
    const renderBookingAvailability = () => {
        if (content.type === 'recipe' || content.type === 'website' || !content.bookable) {
            return react_1.default.createElement(Book, { className: "hidden" }, "a");
        }
        const bookingState = content.availability ? content.availability.availabilityState : 'available';
        const bookingButtonText = content.availability
            ? content.availability.textsForDisplay.availabilityState
            : i18n_js_1.default.t('book_now');
        let bookingColor = '';
        switch (content.availability && content.availability.availabilityState) {
            case 'available':
                bookingColor = 'green';
                break;
            case 'sold_out':
            case 'not_bookable_anymore':
            case 'not_yet_bookable':
            case 'disabled':
            case 'canceled':
                bookingColor = 'red';
                break;
            case 'user_has_active_booking':
                bookingColor = 'blue';
                break;
            case 'few_places_left':
                bookingColor = 'yellow';
                break;
            default:
                bookingColor = 'green';
        }
        return (react_1.default.createElement(Book, { state: bookingState, slug: venue.slug },
            react_1.default.createElement("div", { className: `booking-circle ${bookingColor}` }),
            react_1.default.createElement(Typography_1.default, { variant: "body2" }, bookingButtonText)));
    };
    const showType = window.location.search.includes('dev-mode=true');
    const renderListItem = () => (react_1.default.createElement(StylingWrapper, { id: index ? `aqa_activities_page_activity_${index} ` : null },
        react_1.default.createElement(Item, { onClick: () => {
                if (content) {
                    const redirectLocation = content.deeplink
                        ? new URL(content.deeplink).pathname
                        : `/directory/page/${content.title.toLowerCase().replace(/ /g, '-')}`;
                    const transitionToItemDetail = () => {
                        history.push({
                            pathname: `${redirectLocation}`,
                            search: location.search,
                        });
                    };
                    transitionToItemDetail();
                    const event = new CustomEvent('modalOpenWasRequested');
                    window.dispatchEvent(event);
                }
            } },
            content.smallImage ? (react_1.default.createElement(ProgressiveImage_1.default, { image: content.smallImage, alt: content.title, imageClass: "progressive-image" })) : (react_1.default.createElement(ItemImage, { className: "item-image" })),
            react_1.default.createElement(ItemContent, null,
                react_1.default.createElement(PlaceAndTime, { className: "place-time" },
                    react_1.default.createElement(Place, null, content.placeName && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Place_1.default, null),
                        react_1.default.createElement(Typography_1.default, { variant: "body2" }, content.placeName))))),
                react_1.default.createElement(TitleWrapper, { className: "title" },
                    react_1.default.createElement("p", null, `${content.title} ${showType ? '-Page' : ''} `)),
                react_1.default.createElement("div", null, renderBookingAvailability())))));
    if (withLazyLoad) {
        return (
        // @ts-ignore
        react_1.default.createElement(react_intersection_observer_1.InView // CHECK
        , { triggerOnce: true, as: "div", onChange: inView => {
                if (inView) {
                    setIsVisible(true);
                }
            } }, isVisible && react_1.default.createElement(react_1.default.Fragment, null, renderListItem())));
    }
    return react_1.default.createElement(react_1.default.Fragment, null, renderListItem());
};
exports.ListItem = ListItem;
const mapStoreToProps = store => ({
    backofficeSettings: store.getValue('backofficeSettings'),
    venue: store.getValue('venue'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.ListItem));
